// Import the core angular services.
import { ErrorHandler } from '@angular/core';
import { forwardRef } from '@angular/core';
import { Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ErrorLogService } from './index';
import { environment } from '../environments/environment';

export interface LoggingErrorHandlerOptions {
    rethrowError: boolean;
    unwrapError: boolean;
}

// export var LOGGING_ERROR_HANDLER_OPTIONS: LoggingErrorHandlerOptions = {
//     rethrowError: false,
//     unwrapError: false
// };


@Injectable()
export class LoggingErrorHandler implements ErrorHandler {

    private errorLogService: ErrorLogService;
    private options: LoggingErrorHandlerOptions;
    constructor(errorLogService: ErrorLogService) {
        this.errorLogService = errorLogService;
        this.options = {
            rethrowError: false,
            unwrapError: false
        };
    }

    public handleError(error: any): void {
        try {
            console.group('ErrorHandler');
            if (error.message) {
                console.error(error.message);
            }
            if (error.stack) {
                console.error(error.stack);
            }
            console.groupEnd();
        } catch (handlingError) {
            console.group('ErrorHandler');
            console.warn('Error when trying to output error.');
            console.error(handlingError);
            console.groupEnd();
        }
        if (environment.production === true) {
            try {
                this.options.unwrapError
                    ? this.errorLogService.sendToServer(this.findOriginalError(error))
                    : this.errorLogService.sendToServer(error);
            } catch (loggingError) {
                console.group('ErrorHandler');
                console.warn('Error when trying to log error to', this.errorLogService);
                console.error(loggingError);
                console.groupEnd();
            }
        }
        if (this.options.rethrowError) {
            throw (error);
        }
    }

    private findOriginalError(error: any): any {
        while (error && error.originalError) {
            error = error.originalError;
        }
        return (error);
    }

}

// export var LOGGING_ERROR_HANDLER_PROVIDERS = [
//     {
//         provide: LOGGING_ERROR_HANDLER_OPTIONS,
//         useFactory: LOGGING_ERROR_HANDLER_OPTIONS
//     },
//     {
//         provide: ErrorHandler,
//         useClass: LoggingErrorHandler
//     }
// ];




// WEBPACK FOOTER //
// ./src/app/app.exceptionhandler.ts